module.exports = __webpack_public_path__ + "assets/img/NUS.c1408be5.jpg";